"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SubRowButtonHolder = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("../../elements/icons/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SubRowButtonHolder = _styledComponents["default"].div.attrs(function () {
  return {};
}).withConfig({
  displayName: "SubrowButton__SubRowButtonHolder",
  componentId: "sc-6p2ae4-0"
})(["min-width:31px;visibility:", ";"], function (props) {
  return props.isVisible === "hidden" ? "hidden" : "visible";
});

exports.SubRowButtonHolder = SubRowButtonHolder;

var SubrowButton = function SubrowButton(_ref) {
  var expanded = _ref.expanded,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      isVisible = _ref.isVisible;
  return _react["default"].createElement(SubRowButtonHolder, {
    isVisible: isVisible
  }, expanded ? _react["default"].createElement(_Icon["default"], {
    iconName: "fa-minus-circle",
    onClick: onClick
  }) : _react["default"].createElement(_react["default"].Fragment, null, !disabled ? _react["default"].createElement(_Icon["default"], {
    iconName: "fa-plus-circle",
    onClick: onClick
  }) : _react["default"].createElement(_Icon["default"], {
    iconName: "fa-plus-circle",
    styles: {
      color: "#dee5ed",
      hoverColor: "#dee5ed"
    }
  })));
};

SubrowButton.propTypes = {
  expanded: _propTypes["default"].bool.isRequired,
  onClick: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  isVisible: _propTypes["default"].string
};
var _default = SubrowButton;
exports["default"] = _default;